import Vue from 'vue'
import axios from './plugins/axios'
import App from './App.vue'
import store from './store'
import router from './router'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css' // import style (<= Swiper 5.x)

Vue.use(VueAwesomeSwiper, {
  destroy: () => { console.log('destroy') }
})

import VueProgressBar from 'vue-progressbar'



Vue.use(VueProgressBar, {
  color: '#2e6fef',
  failedColor: 'red',
  thickness: '4px',
})


Vue.config.productionTip = false

Vue.prototype.$http = axios;

// //////// plugin BEGIN
import AppCallPlugin from './plugins/AppCallPlugin';
import ReviewScorePlugin from './plugins/ReviewScorePlugin';
import PrebookMathPlugin from './plugins/PrebookMathPlugin';
import KakaoMapCroodsPlugin from './plugins/KakaoMapCroodsPlugin';

Vue.use(AppCallPlugin);
Vue.use(ReviewScorePlugin);
Vue.use(PrebookMathPlugin);
Vue.use(KakaoMapCroodsPlugin);
// //////// plugin END


// //////// minxin BEGIN
import { ApiResponseFunc } from './mixins/ApiResponseMixin';
Vue.mixin(ApiResponseFunc);
import { AuthCheckMixin } from './mixins/AuthCheckMixin';
Vue.mixin(AuthCheckMixin);
// //////// minxin END

// //////// components BEGIN
import NoneData from './components/NoneData.vue';
Vue.component('none-data',NoneData);
// //////// components END


// // //////// social BEGIN
// import GAuth from 'vue-google-oauth2'
// const gauthOption = {
//   clientId: store.state.googleClientId,
//   scope: store.state.googleScope,
// }
// Vue.use(GAuth, gauthOption)
// window.Kakao.init(store.state.kakaoClientId);
// //////// social END

setMountVue();

import {
  getlocalStorageToken,
  setAxiosDefaultsHeadersCommonAuthorizationToken
} from './utils/auth';

async function setMountVue() {
  
  let token = getlocalStorageToken();

  if(token) 
  {
    setAxiosDefaultsHeadersCommonAuthorizationToken();
    store.dispatch('GET_AUTH');
  }

  await store.dispatch('GET_CODE_DICTIONARY_LIST');
  // await store.dispatch('GET_BRAND_LIST');

  var vm = new Vue({
    store,
    router,
    render: h => h(App),
    watch: {
      '$route' () {
        this.$_clearStatsDatas();
      }
    },
    mounted() {
      // alert("Vue main.js mounted");
      let lat = localStorage.getItem("CURRENT_LOCATION_LAT", lat);
      let har = localStorage.getItem("CURRENT_LOCATION_HAR", har);

      // local vuex ����� test ���Դϴ�. Ȯ�� �� �����ּ���
      // lat = lat ? lat : "37.52302";
      // har = har ? har : "127.07654";

      // alert("Vue main.js mounted lat:: "+lat);
      // alert("Vue main.js mounted har:: "+har);
      
      localStorage.removeItem("CURRENT_LOCATION_LAT");
      localStorage.removeItem("CURRENT_LOCATION_HAR");
      
      if(lat && har) {
        this.$store.commit('SET_CURRENT_LOCATION',{ lat, har });
      }

    }
  }).$mount('#app')
  

  window.app = vm;
  
}


